/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { SUBMISSION_STATUS } from '../../config';

export const LOADING = "loading";
export const LOADED = "loaded";
export const FAILED = "failed";
export const DENIED = "denied";

const slice = createSlice({
  name: "courseware",
  initialState: {
    courseStatus: "loading",
    courseId: null,
    sequenceStatus: "loading",
    sequenceId: null,
    sequenceMightBeUnit: false,
    electivesStatus: LOADING,
    updateElectivesStatus: LOADING,
    isSequenceDeleted: false,
    selectedSequenceStatus: "",
    selectedSequenceId: null,
    electiveAfterSubmitModalOpen: false,
    totalSelectedElectives: 0,
  },
  reducers: {
    fetchCourseRequest: (state, { payload }) => {
      state.courseId = payload.courseId;
      state.courseStatus = LOADING;
    },
    fetchCourseSuccess: (state, { payload }) => {
      state.courseId = payload.courseId;
      state.courseStatus = LOADED;
    },
    fetchCourseFailure: (state, { payload }) => {
      state.courseId = payload.courseId;
      state.courseStatus = FAILED;
    },
    fetchCourseDenied: (state, { payload }) => {
      state.courseId = payload.courseId;
      state.courseStatus = DENIED;
    },
    fetchSequenceRequest: (state, { payload }) => {
      state.sequenceId = payload.sequenceId;
      state.sequenceStatus = LOADING;
      state.sequenceMightBeUnit = false;
      state.isSequenceDeleted = false;
    },
    fetchSequenceSuccess: (state, { payload }) => {
      state.sequenceId = payload.sequenceId;
      state.sequenceStatus = LOADED;
      state.sequenceMightBeUnit = false;
      state.isSequenceDeleted = false;
    },
    fetchSequenceFailure: (state, { payload }) => {
      state.sequenceId = payload.sequenceId;
      state.sequenceStatus = FAILED;
      state.sequenceMightBeUnit = payload.sequenceMightBeUnit || false;
      state.isSequenceDeleted = payload.isSequenceDeleted || false;
    },
    fetchElectivesRequest: (state) => {
      state.electivesStatus = LOADING;
    },
    fetchElectivesSuccess: (state) => {
      state.electivesStatus = LOADED;
    },
    fetchElectivesFailure: (state) => {
      state.electivesStatus = FAILED;
    },
    updateElectivesRequest: (state) => {
      state.updateElectivesStatus = SUBMISSION_STATUS.SUBMITTING;
    },
    updateElectivesSuccess: (state) => {
      state.updateElectivesStatus = SUBMISSION_STATUS.SUBMITTED;
    },
    updateElectivesFailure: (state) => {
      state.updateElectivesStatus = SUBMISSION_STATUS.FAILED;
    },
    fetchSequenceUnitsForSidebarRequest: (state, { payload }) => {
      state.selectedSequenceId = payload.sequenceId;
      state.selectedSequenceStatus = LOADING;
    },
    fetchSequenceUnitsForSidebarSuccess: (state, { payload }) => {
      state.selectedSequenceId = payload.sequenceId;
      state.selectedSequenceStatus = LOADED;
    },
    fetchSequenceUnitsForSidebarFailure: (state, { payload }) => {
      state.selectedSequenceId = payload.sequenceId;
      state.selectedSequenceStatus = FAILED;
    },
    setElectiveAfterSubmitModalOpen: (state, { payload }) => {
      state.electiveAfterSubmitModalOpen = payload;
    },
    setTotalSelectedElectives: (state, { payload }) => {
      state.totalSelectedElectives = payload;
    },
  },
});

export const {
  fetchCourseRequest,
  fetchCourseSuccess,
  fetchCourseFailure,
  fetchCourseDenied,
  fetchSequenceRequest,
  fetchSequenceSuccess,
  fetchSequenceFailure,
  fetchCourseRecommendationsRequest,
  fetchCourseRecommendationsSuccess,
  fetchCourseRecommendationsFailure,
  fetchElectivesRequest,
  fetchElectivesSuccess,
  fetchElectivesFailure,
  updateElectivesRequest,
  updateElectivesSuccess,
  updateElectivesFailure,
  fetchSequenceUnitsForSidebarRequest,
  fetchSequenceUnitsForSidebarSuccess,
  fetchSequenceUnitsForSidebarFailure,
  setElectiveAfterSubmitModalOpen,
  setTotalSelectedElectives,
} = slice.actions;

export const { reducer } = slice;
